import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Role } from '@never2busy/shared';
import { LoginPage } from './features/auth/pages/LoginPage';
import { ProtectedRoute } from './features/auth/components/ProtectedRoute';
import { AppLayout } from './components/layout/AppLayout';
import { AccountsListPage } from './features/accounts/pages/AccountsListPage';
import { AccountDetailPage } from './features/accounts/pages/AccountDetailPage';
import { AccountEditPage } from './features/accounts/pages/AccountEditPage';
import { PersonsListPage } from './features/persons/pages/PersonsListPage';
import { PersonDetailPage } from './features/persons/pages/PersonDetailPage';
import { PersonEditPage } from './features/persons/pages/PersonEditPage';
import { ActivitiesListPage } from './features/activities/pages/ActivitiesListPage';
import { CalendarPage } from './features/activities/pages/CalendarPage';
import { ActivityDetailPage } from './features/activities/pages/ActivityDetailPage';
import { ActivityEditPage } from './features/activities/pages/ActivityEditPage';
import { UsersAdminPage } from './features/admin/pages/UsersAdminPage';
import { ProfilePage } from './features/profile/pages/ProfilePage';
import { DashboardPage } from './features/dashboard/pages/DashboardPage';
import { ProjectsListPage } from './features/projects/pages/ProjectsListPage';
import { ProjectDetailPage } from './features/projects/pages/ProjectDetailPage';
import { ProjectEditPage } from './features/projects/pages/ProjectEditPage';
import { SalesListPage } from './features/sales/pages/SalesListPage';
import { SaleDetailPage } from './features/sales/pages/SaleDetailPage';
import { SaleEditPage } from './features/sales/pages/SaleEditPage';
import { SalesPipelinePage } from './features/sales/pages/SalesPipelinePage';
import { ReportsPage } from './features/reports/pages/ReportsPage';
import { KeywordsAdminPage } from './features/keywords/pages/KeywordsAdminPage';
import { LookupsAdminPage } from './features/lookups/pages/LookupsAdminPage';
import { AuditLogPage } from './features/audit/pages/AuditLogPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/', element: <DashboardPage /> },
          { path: '/cuentas', element: <AccountsListPage /> },
          { path: '/cuentas/nueva', element: <AccountEditPage /> },
          { path: '/cuentas/:id', element: <AccountDetailPage /> },
          { path: '/cuentas/:id/editar', element: <AccountEditPage /> },
          { path: '/contactos', element: <PersonsListPage /> },
          { path: '/contactos/nuevo', element: <PersonEditPage /> },
          { path: '/contactos/:id', element: <PersonDetailPage /> },
          { path: '/contactos/:id/editar', element: <PersonEditPage /> },
          { path: '/proyectos', element: <ProjectsListPage /> },
          { path: '/proyectos/nuevo', element: <ProjectEditPage /> },
          { path: '/proyectos/:id', element: <ProjectDetailPage /> },
          { path: '/proyectos/:id/editar', element: <ProjectEditPage /> },
          { path: '/ventas', element: <SalesListPage /> },
          { path: '/ventas/pipeline', element: <SalesPipelinePage /> },
          { path: '/ventas/nueva', element: <SaleEditPage /> },
          { path: '/ventas/:id', element: <SaleDetailPage /> },
          { path: '/ventas/:id/editar', element: <SaleEditPage /> },
          { path: '/actividades', element: <ActivitiesListPage /> },
          { path: '/calendario', element: <CalendarPage /> },
          { path: '/actividades/nueva', element: <ActivityEditPage /> },
          { path: '/actividades/:id', element: <ActivityDetailPage /> },
          { path: '/actividades/:id/editar', element: <ActivityEditPage /> },
          { path: '/reportes', element: <ReportsPage /> },
          { path: '/perfil', element: <ProfilePage /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute roles={[Role.ADMIN, Role.GERENTE]} />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/admin/etiquetas', element: <KeywordsAdminPage /> },
          { path: '/admin/catalogos', element: <LookupsAdminPage /> },
        ],
      },
    ],
  },
  {
    element: <ProtectedRoute roles={[Role.ADMIN]} />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { path: '/admin/usuarios', element: <UsersAdminPage /> },
          { path: '/admin/auditoria', element: <AuditLogPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
